import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.notes', {
        url: '/notes',
        views: {
            '': 'userPublicNotes',
            'header@user': 'userPublicUserAccountsHeader',
        },
        resolve: {notes},
    })
}

/** @ngInject */
function notes($filter, UserNotesService) {
    return UserNotesService.query().$promise
            .then((items) => $filter('orderBy')(items, '-updatedOn'));
}





// WEBPACK FOOTER //
// ./src/portal/states/user/notes/notes.state.js